import React, { useState } from "react";

import { Col, Row, Typography, Layout, Card, Space, Image } from "antd";
import { HeartFilled, HeartOutlined } from "@ant-design/icons";
// import book1 from "../../assets/new-book1.png";
// import book2 from "../../assets/new-book2.png";
// import book3 from "../../assets/new-book3.png";
// import book4 from "../../assets/new-book4.png";
import { ImageUrl } from "../../helpers/Function";
import { useNavigate } from "react-router";

const books = [
    {
        id: 1,
        title: "Harry Potter",
        isFav: false,
        price: "$15.00",
        author: "J.K Rowling",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
        image: "new-book1.png",
    },
    {
        id: 2,
        title: "Realm of Ruins",
        isFav: false,
        price: "$20.00",
        available: "Available",
        author: "Hannah West",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
            image: "new-book2.png",
    },
    {
        id: 3,
        title: "Dark Gathering",
        isFav: false,
        price: "$15.00",
        author: "Leigh Bardugo",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
            image: "new-book3.png",
    },
    {
        id: 4,
        title: "Thalgor’s Witch",
        isFav: false,
        price: "$20.00",
        author: "Nancy Holland",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
            image: "new-book4.png",
    },
    {
        id: 5,
        title: "Harry Potter",
        isFav: false,
        price: "$15.00",
        author: "J.K Rowling",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
            image: "new-book5.png",
    },
    {
        id: 6,
        title: "Realm of Ruins",
        isFav: false,
        price: "$20.00",
        author: "Hannah West",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
            image: "new-book3.png",
    },
    {
        id: 7,
        title: "Dark Gathering",
        isFav: false,
        price: "$15.00",
        author: "Leigh Bardugo",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
            image: "new-book2.png",
    },
    {
        id: 8,
        title: "Thalgor’s Witch",
        isFav: false,
        price: "$20.00",
        author: "Nancy Holland",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
            image: "new-book5.png",
    },

];

function AboutUs() {
    const navigate = useNavigate();
    const [booklist, setBookList] = useState([...books]);
    // setFavorites((prev) => ({
    //   ...prev,
    //   [id]: !prev[id],
    // }));
    const toggleFavorite = (id, index) => {
        books[index].isFav = !books[index].isFav;
        setBookList([...books]);
    };
    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Row
                className="blueBackground-old booksbanner"
                style={{
                    height: "55vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Typography.Title
                    className="fontFamily1 aboutbanner-content newfont"
                    style={{ fontSize: "46px", color: "#000" }}
                >
                    {<> Books</>}
                </Typography.Title>
            </Row>

            {/* section 2 */}
            <Row
                className="whiteBackground"
                style={{ backgroundColor: "white", justifyContent: "center" }}
            >
                <Col xs={24} md={16}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",

                            padding: "50px 20px",
                        }}
                    >
                        <Card
                            className="infoBox"
                            bordered={false}
                            style={{
                                width: "100%",
                                padding: "20px",
                            }}
                        >
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                                    gap: "16px",
                                    padding: "16px",
                                }}
                                className="book-grid"
                            >
                                {booklist.map((book, index) => (
                                    <Space
                                        key={book.id}
                                        direction="vertical"
                                        size="middle"
                                        style={{
                                            width: "100%",
                                            padding: "8px",
                                        }}
                                    >
                                        <Card
                                            className="ad-card"
                                            style={{ backgroundColor: "transparent", border: "none" }}
                                            cover={
                                                <div style={{ position: "relative" }}>
                                                    <span
                                                        className="cursor-pointer"
                                                    onClick={() =>
                                                        navigate("/books/" + book?.id, { state: { index } })
                                                    }
                                                    >
                                                        {/* {book.image} */}
                                                        <Image
                                                            preview={false}
                                                            alt={"Failed to load image"}
                                                            src={ImageUrl(book.image)}
                                                            style={{
                                                                Width: "100%",
                                                                maxHeight: "480px",
                                                                objectFit: "cover",
                                                                borderRadius: "10px",
                                                                objectPosition: "center",
                                                            }}
                                                        />
                                                    </span>
                                                    
                                                </div>
                                            }
                                        >
                                            <h4 className="book-title fontFamily1">
                                                {book.title}{" "}
                                                <span className="book-price fontFamily1">{book.price}</span>
                                            </h4>
                                            <h6 className="book-subtitle fontFamily1">{book.author}</h6>
                                        </Card>
                                    </Space>
                                ))}
                            </div>
                        </Card>
                    </div>
                </Col>
            </Row>
        </Layout>
    );
}

export default AboutUs;
